// Module
var code = "<button class=\"btn btn-xs btn-link padding-0-2\" ng-click=\"$ctrl.removePrelevement($ctrl.lig)\" uib-tooltip=\"{{'SYNTHENTS.ECARTER_LIGNE' | translate}}\" tooltip-placement=\"left\"> <span class=\"glyphicon glyphicon-minus\"></span> </button> ";
// Exports
module.exports = code;